module.exports = __webpack_public_path__ + "static/Interactive Fulldome-25cf059d96c41cad43dbd86d13088072.png";